import { Directive, ElementRef, NgZone } from "@angular/core";
import fastdom from "fastdom";

@Directive({
    selector: "[game-multiplier]"
})
export class GameMultiplierDirective {
    constructor(private el: ElementRef,
                private ngZone: NgZone) {
    }

    onMultiplierUpdate(multiplier: number): void {
        this.ngZone.runOutsideAngular(() => {
            fastdom.mutate(() => {
                this.el.nativeElement.innerText = multiplier.toFixed(2);
            });
        });
    }
}
